export default "__VITE_ASSET__BSJdPh2d__"